import React from 'react';
import { MODE_SELECTION_OPTIONS, SELECT_MODE_LABEL } from '../ARSConstants';
import { ModeSelectionType } from '../Types';
import Dropdown from 'Components/DesignSystem/Dropdown/Dropdown';

type ModeSelectionDropdownProps = {
    value: ModeSelectionType;
    onChange: (value: ModeSelectionType) => void;
    disabled?: boolean;
    id?: string;
};

export const ModeSelectionDropdown = ({
    value,
    onChange,
    disabled = false,
    id = 'mode-selection-dropdown'
}: ModeSelectionDropdownProps) => {
    const handleChange = (e: string | number) => {
        onChange(String(e) as ModeSelectionType);
    };

    return (
        <div className="tw-flex tw-flex-col tw-gap-1" data-testid={id}>
            <label
                htmlFor={`${id}-select`}
                className="tw-text-[#6d788c] tw-text-sm tw-leading-tight"
            >
                {SELECT_MODE_LABEL}
            </label>
            <Dropdown
                label=""
                value={value}
                onChange={handleChange}
                disabled={disabled}
                data-testid={`${id}-select`}
                className='tw-w-40'
                options={MODE_SELECTION_OPTIONS.map((option) => ({
                    label: option.label,
                    value: option.value
                }))}
            />
        </div>
    );
};

export default ModeSelectionDropdown;